<template>
  <main class="content">
    <!-- content -->
    <section class="add" v-if="article.html">
      <div class='container'>

        <div class="add__wrapper">
          <h1 class="add__title">{{article.name}}</h1>
          <!--p class="add__subtitle">от 09.07.2020</p-->
          <div class="add__text">
            <v-runtime-template :template="article.html"/>
          </div>
        </div>
      </div>
    </section>
    <section class="abort" v-else>
      <div class='container'>
        <div class="abort__inner">
          <div class="abort__text">
            <h3 class="abort__title">Ошибка 404</h3>
            <p class="abort__subtitle">Такая страница не найдена</p>
            <div class="abort-btn__wrapper">
              <button class="abort__btn">На главную</button>
            </div>
          </div>
          <div class="abort__picture">
            <picture><source srcset="/static/img/404/1.svg" type="image/webp"><img src="/static/img/404/1.svg" alt="" /></picture>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
  name: 'article',
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      article: {},
      situations: []
    }
  },
  methods: {
    initPage () {
      axios.get('https://bez.v-avtoservice.com/list/get-article?link=' + window.location.pathname).then(response => {
        this.article = response.data
        this.article.html = '<div>' + this.article.html.replace(/{showDoc}/gi, '<button class="get-doc" @click="showModal()">').replace(/{\/showDoc}/gi, '</button>') + '</div>'
      })
    },
    showModal () {
      this.$root.requestModal = 1
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article.vue